import SignupForm from '@features/signup/signup-form/signup-form';
export default SignupForm;
